function initProductValidation(){
    _productValidation.Items = _productValidation.Formular.find("*[validate='true']");
    _productValidation.SummeryBox = $(".productError");
}
function validateProduct(){
	var orderLineSet = $(".incartProduct").length;
	var productSet = $(".productPreview").hasClass("productSet");

	if(orderLineSet !== 0 && productSet === false){
		return true;
	}
	else{
		_productValidation.ShowSummery = true;
	    _productValidation.Validate();
	    return _productValidation.IsValid;
	}
}

function initUserValidation(){
    _userValidation.Items = _userValidation.Formular.find("*[validate='true']");
    _userValidation.SummeryBox = $(".userError");
}
function validateUser(){
	_userValidation.ShowSummery = true;
    _userValidation.Validate();
    return _userValidation.IsValid;
}

function initDatePicker(){
	//TLA
	var dateformat = $("body").data("dateformat");
	if (dateformat === "")
		dateformat = "dd-mm-yy";
		
	$(".datePicker").datepicker({
		dateFormat: dateformat,
		maxDate:0,
		changeMonth: true,
		changeYear:true
	});
}

function initSelectMenu(){
	$("select").selectmenu();
	$(".customerName").selectmenu().selectmenu("menuWidget").addClass("overflow");
}

function calibrationServiceTypeValidation(){
	var _serviceId = $(".servicetype").find("option:selected").val();

	if(_serviceId){
		if(_serviceId == 22 || _serviceId == 25){
			$("#EcomOrderLineFieldInput_boughtdate, #EcomOrderLineFieldInput_boughtat").attr("validate", "true");
		}
		else{
			$("#EcomOrderLineFieldInput_boughtdate, #EcomOrderLineFieldInput_boughtat").attr("validate", "false");
		}
	}
}

function firmChange(){
	var _form = $(".firmdrop form");
	var _currentFirm = _form.data("currentfirm");
	var _currentText = $("#firmDrop option:selected").text();
	$("#firmDrop").selectmenu({
	  select: function(event, ui) {
	  	var _value = ui.item.value;

	  	if(_value != _currentFirm){
			swal({
				title: _form.data("title"),
				text: _form.data("text"),
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#DD6B55",
				confirmButtonText: _form.data("confirmbuttontext"),
				cancelButtonText: _form.data("cancelbuttontext"),
				closeOnConfirm: false,
				closeOnCancel: true
			},
			function(isConfirm){
				if (isConfirm) {
					_form.submit();
				}
				else{
					$(".ui-selectmenu-text").text(_currentText);
				}
			});
	  	}
	  }
	});
}

function serviceTypeChange(){
	var _serviceType = $("#EcomOrderLineFieldInput_servicetype");
	var _boughtAtAndDate = $("#EcomOrderLineFieldInput_boughtdate, #EcomOrderLineFieldInput_boughtat");
	var _textarea = $("#EcomOrderLineFieldInput_errormessage");

	_serviceType.val("");

	$("#EcomOrderLineFieldInput_servicetypevalue").selectmenu({
	  select: function(event, ui) {
	  	var _index = ui.item.index;
	  	var _this = $(this);
	  	var _serviceId = ui.item.value;

	  	_serviceType.val("");
	  	if(_index === 0){
	  		_boughtAtAndDate.attr("validate", "false");
	  	}
	  	else{
	  		_serviceType.val(_this.find("option:selected").text());

	  		if(_serviceId == 22 || _serviceId == 25){
	  			_boughtAtAndDate.attr("validate", "true");
	  		}
	  		else{
	  			_boughtAtAndDate.attr("validate", "false");
	  		}

	  		if(_serviceId == 23){
	  			_textarea.attr("allowblank", "true");
	  		}
	  		else{
	  			_textarea.attr("allowblank", "false");
	  		}
	  	}

	  	initProductValidation();
	  }
	});
}

function customerTypeChange(){
	$("#CustomerType").selectmenu({
	  select: function(event, ui) {
	  	var _index = ui.item.index;
	  	var _this = $(this);
	  	var _customerTypeKey = _this.find("option:selected").data("key");
	  	var _company = $("#firmDrop").find("option:selected").val();
	  	var _login = $("#ordersubmit").data("login");

	  	if(_index === 0){
	  		$("#CustomerTypeValue").val("");
	  		$("#EcomOrderCustomerCompany").attr("validate", "false");
	  		$("#EcomOrderCustomerEAN").attr("allowblank", "true");
  			$("#EcomOrderCustomerVatRegNumber").attr("allowblank", "true");
	  	}
	  	else{
	  		$("#CustomerTypeValue").val(_customerTypeKey);

	  		if(_customerTypeKey == 2){
	  			$("#EcomOrderCustomerCompany").attr("validate", "true");
	  			$("#EcomOrderCustomerEAN").attr("allowblank", "true");
	  			$("#EcomOrderCustomerVatRegNumber").attr("allowblank", "false");
	  		}
	  		else if(_customerTypeKey == 3){
	  			$("#EcomOrderCustomerCompany").attr("validate", "true");
	  			$("#EcomOrderCustomerEAN").attr("allowblank", "false");
  				$("#EcomOrderCustomerVatRegNumber").attr("allowblank", "false");
	  		}
	  		else{
	  			$("#EcomOrderCustomerCompany").attr("validate", "false");
	  			$("#EcomOrderCustomerEAN").attr("allowblank", "true");
	  			$("#EcomOrderCustomerVatRegNumber").attr("allowblank", "true");
	  		}
	  	}

	  	initUserValidation();
	  }
	});
}

var contactChosen = false;
function newContact(){
	$(".customerName").selectmenu({
	  select: function(event, ui) {
	  	var _this = ui.item.index;
	  	var _label = ui.item.label;
	  	
	  	if(_this === 0){
	  		$(".newContact").slideUp(500).find("input").prop("disabled", true).attr("validate", "false").parent().find("input[type=checkbox]").prop("checked", false);
	  		$("#EcomOrderCustomerName").val(_label);
	  		contactChosen = false;
	  	}
	  	else if(_this == 1){
	  		$(".newContact").slideDown(500).find("input").prop("disabled", false).attr("validate", "true").parent().find("input[type=checkbox]").prop("checked", true);
	  		$("#EcomOrderCustomerName").val($("#NewContactName").val());
	  		contactChosen = true;
	  	}
	  	else{
	  		$(".newContact").slideUp(500).find("input").prop("disabled", true).attr("validate", "false").parent().find("input[type=checkbox]").prop("checked", false);
	  		$("#EcomOrderCustomerName").val(_label);
	  		contactChosen = true;
	  	}

	  	initUserValidation();
	  }
	});
}

function newContactNameInCustomerName(){
	$("#EcomOrderCustomerName").val($("#NewContactName").val());
}

function checkNewsletter(){
	var _radiovalue = $(".newsradio:checked").attr("data-value");
	
	if(_radiovalue == "1"){
		$("#CanContactNewsletter").prop("checked", true).val(true);
	}
	else if(_radiovalue == "0"){
		$("#CanContactNewsletter").prop("checked", false).val(true);
	}
}

function validateCustomer(){
	return contactChosen;
}

function validatePhone(){
	if($("#NewContactPhone").val() != '' || $("#NewContactMobile").val() != ''){
		return true;
	}

	return false;
}

function toggleProductInfo(){
	var _this = $(this);
	var _serial = _this.data("serial");

	$(".wrap[data-serial='" + _serial + "']").slideToggle(500);
	_this.toggleClass("open");
}	

var myDropzone;
var dropActive = false;
function initDropZone(containerId){
	if($(containerId).length > 0){
		var removeMessage = $(".dz-removeMessage").text();
		var errorMessage = $(".dz-errorfile").text();
		
		
		myDropzone = new Dropzone(containerId, { 
			url: "/Handlers/DropzoneUpload.ashx", 
			autoProcessQueue: false,
			addRemoveLinks: true,
			maxFilesize: 3,
			dictRemoveFile: '',
			dictFileTooBig: errorMessage,
			maxFiles: 1,
			dictMaxFilesExceeded: "Du kan ikke uploade flere filer."
		});
		var fallback = $(".drop").hasClass("dz-browser-not-supported");

		if(fallback === false){
			dropZoneActive();
		}
		else{
			$("label[for=dropZoneContainer]").addClass("fallback");
		}
		
	}
}

function dropZoneActive(){
	var $messageBox = $('.js-dz-message');

	myDropzone.on("addedfile", function(file) {
		$messageBox.addClass('hidden');
		dropActive = true;
	});

	myDropzone.on("removedfile", function(file) {
		dropActive = false;
		if (myDropzone.files.length === 0) {
			$messageBox.removeClass('hidden');
		}
	});
}



var dropZoneArray = [];
var dropZoneActiveArray = [];
function initMultiDropZone(cssClass){
	var _length = $(cssClass).length;

	for(var i = 0; i < _length; i++){
		var containerId = "#dropZoneContainer" + (i + 1);

		if($(containerId).length > 0){
			var removeMessage = $(containerId + " .dz-removeMessage").text();
			dropZoneArray[i] = containerId;
			var orderline = $(containerId).data("orderline");
			var errorMessage = $(containerId + " .dz-errorfile").text();
			
			dropZoneArray[i] = new Dropzone(containerId, { 
				url: "/Handlers/DropzoneUpload.ashx?orderlineid=" + orderline, 
				autoProcessQueue: false,
				addRemoveLinks: true,
				maxFilesize: 3,
				dictRemoveFile: removeMessage,
				dictFileTooBig: errorMessage,
				maxFiles: 1
			});

			dropZoneActiveArray[i] = 0;

			var fallback = $(".drop").hasClass("dz-browser-not-supported");

			if(fallback === false){
				multiDropZoneActive(dropZoneArray[i], i);
			}
			else{
				$("label[for=dropZoneContainer]").addClass("fallback");
			}
		}
	}
}

function multiDropZoneActive(dropZoneId, count){
	dropZoneId.on("addedfile", function(file) {
		dropZoneActiveArray[count] = 1;
	});

	dropZoneId.on("removedfile", function(file) {
		dropZoneActiveArray[count] = 0;
	});
}

function submitStep0(e){
	var addMore = $(e.target).hasClass("addMoreProducts");
  var isValid = validateProduct();
  
	if(isValid === true){
		if(dropActive === true){
			myDropzone.processQueue();
			myDropzone.on("complete", function(file) {
				submitForm(addMore);
			});
		}
		else{
      
			submitForm(addMore);
		}
	} else {
    document.getElementsByClassName('productError')[0].scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
  }
}

function multiSubmitStep0(e){
	var isValid = validateProduct();

	if(isValid === true){
        if (isValid === true) {
            if (dropZoneActiveArray.indexOf(1) !== -1) {
                var lastActiveIndex = -1;

                for (var i = 0; i < dropZoneActiveArray.length; i++) {
                    if (dropZoneActiveArray[i] === 1) {
                        dropZoneArray[i].processQueue();
                        lastActiveIndex = i;
                    }
                }

                if (lastActiveIndex !== -1) {
                    var onAllUploadsComplete = function (file) {
                        $(".formStep0#ordersubmit").submit();
                    };

                    dropZoneArray[lastActiveIndex].on("complete", onAllUploadsComplete);
                }
            }
        }
        else{
			$(".formStep0#ordersubmit").submit();
		}
	}
}

function submitForm(addMore){
	if(addMore === false){
		goToStep1();
	}
	else{
		goToStep0();
	}
}

function goToStep0(){
	$("#back").prop('disabled', false);
	$("#forward").prop('disabled', true);

	var _this = $(".addMoreProducts");
	swal({
	  title: _this.data("title"),
	  text: _this.data("text"),
	  type: "success",
	  showConfirmButton: false
	});

	window.setTimeout(function(){
		$(".formStep0#ordersubmit").submit();
	},500);
}

function goToStep1(){
	$("#back").prop('disabled', true);
	$("#forward").prop('disabled', false);
	$(".formStep0#ordersubmit").submit();
}